import { EnvironmentConfig } from "@environments/environments.type";

export const environment: EnvironmentConfig = {
  production: false,
  environmentName: "staging",
  baseRef: "/exercices/exerciseur/homophones",
  squidex: {
    appName: "ap-homophones-ei",
    clientId: "ap-homophones-ei:ap-homophones-read-only",
    clientSecret: "s2xtidwhfeu6hx8ds8clxgzgs4upqfzbolplsaov2y4x",
    url: "https://squidex.alloprof-staging.ca",
  },
  firebase: {
    projectId: "alloprof-stg",
    appId: "1:743539691644:web:d869c3d657ed06dd05b9f9",
    databaseURL: "https://alloprof-stg.firebaseio.com",
    storageBucket: "alloprof-stg.appspot.com",
    apiKey: "AIzaSyDUJy-YDvUNTS56G40x96jdoGQskwfk5Ks",
    authDomain: "alloprof-stg.firebaseapp.com",
    messagingSenderId: "743539691644",
    measurementId: "G-Y4LRJCZFKB",
  },
  firestore: {
    userDataPath: ["exercisers", "apexerciserhomophones", "user_data"],
  },
  iframeConfig: {
    parentOrigin: "https://www.alloprof-staging.ca",
  },
  apFunctions: {
    baseUrl: "https://us-central1-alloprof-stg.cloudfunctions.net",
  },
  audioFile: {
    storageUrl: "https://storage.googleapis.com/ap-public-content-staging/static/exercices/exerciseur/homophones/assets/audios/_assets",
  },
};
